
import FaqList from '~/components/FaqList'

export default {
  name: 'HomeFaq',
  components: { FaqList },
  auth: false,
  async asyncData ({ $axios }) {
    const { data: faqItems } = await $axios.get('v1/faq-sections/1')

    return {
      faqItems: Object.values(faqItems)
    }
  }
}
